
import Util from 'service/util'
import TextMessage from 'view/op/messages/MessageCards/TextMessage'
import ImageMessage from 'view/op/messages/MessageCards/ImageMessage'
import AudioMessage from 'view/op/messages/MessageCards/AudioMessage'
import VideoMessage from 'view/op/messages/MessageCards/VideoMessage'
import DocumentMessage from 'view/op/messages/MessageCards/DocumentMessage'

const MessageBody = ({
  message
}) =>
{
  const { mime_type, message_type } = message

  if (message_type == 'text') {
    return <TextMessage  message={message} />
  }
  else if (String(mime_type||'').split('/')[0] == 'image')
  {
    return <ImageMessage message={message} />
  }
  else switch (mime_type)
  {
    case 'audio/mpeg':
    case 'audio/x-mepg':
    case 'audio/wav':
    case 'audio/x-wav':
    case 'audio/ogg':
    case 'audio/oggm':
    case 'audio/webm':
    case 'audio/acc':
    case 'audio/3gpp':
    case 'audio/3gpp2':
      return <AudioMessage message={message} />
    case 'video/mpeg':
    case 'video/mp4':
    case 'video/webm':
    case 'video/ogg':
    case 'video/x-msvideo':
    case 'video/3gpp':
    case 'video/3gpp2':
      return <VideoMessage message={message} />
  }

  switch (message_type)
  {
    case 'system':
    case 'unsupported':
    case 'reaction':
      return <span className={message_type} data-type={message_type}>不支援訊息類型</span>
  }

  return <DocumentMessage message={message} />
}

const MessageCard = ({
  message
}) =>
{
  const { company, name, phoneNumber, sent_time, sent_company } = message

  return (
    <div className="message-card" data-company={sent_company}>
      <div className="message-card-head">
        <strong className="company">[{ Util.getCompanyName(company) }]</strong>
        <span className="sender-name">{ name }</span>
        <span className="phone-number">{ phoneNumber }</span>
      </div>
      <div className="message-card-body">
        <MessageBody message={message} />
      </div>
      <div className="sent-time">{ sent_time }</div>
    </div>
  )
}

export default MessageCard
